import React,{useRef, useState, useEffect} from "react";
import {Form, Col, Row } from "react-bootstrap";
import {baseMaps} from "../data/baseMaps";
import {overlayMaps} from "../data/overlayMaps";
import {MapTrifold ,Stack  } from "@phosphor-icons/react";

class LayerPanel extends React.Component {

	
	constructor(props) {
		super(props);
		
		
		
		this.layerPanel = React.createRef();

		this.baseMaps = [...[{'thumbnail':'layer_3d.png', 'label':'3D Mode', 'onClick':(e)=>{this.view3d(e)}}], ...baseMaps];
		this.selected = baseMaps[this.props.selected ? this.props.selected : 0];
		this.selectedOverlay = {};
		this.overlayMaps = overlayMaps;

	}
	setLayer(value){
		
	}
	buildAlternatives(){
		
		this.alternatives = baseMaps.filter((a)=>{return a.label !== this.selected.label});
	}
	changeLayer = (opc, e) => {
		
		var self = this;
		if(this.selected.label == this.baseMaps[opc.value].label)
			return false;
		
		this.previous = self.selected.label;
		var prev = this.previous;
		this.props.onChange({value:opc.value-1}, ()=>{
			if(prev == '3D Mode'){
				self.props.view3d.exit(e);
			}
		});
		this.selected = this.baseMaps[opc.value];
		
		this.forceUpdate();
	};
	
	view3d(e){
		
		if(this.selected.label == this.baseMaps[0].label)
			return false;
		
		const swap = {value:1};
		this.props.onChange(swap, ()=>{this.props.view3d.view3d(e)});
		this.selected = this.baseMaps[0];
		
		this.forceUpdate();
		
		;
	}
	
	exitMode(){
		
		
		if(this.selectedOverlay.handler && this.selectedOverlay.handler.exitOverlay){
			this.selectedOverlay.handler.exitOverlay();
		}
		//reset component
		this.selectedOverlay = {};
		this.forceUpdate();
	}
	enterMode(){
		
		if(this.selectedOverlay.handler && this.selectedOverlay.handler.enterOverlay){
			this.selectedOverlay.handler.enterOverlay();
		}
	}
	
	handleChangeOverlay(i){
		
		if(!this.props?.context?.tc?.scenario?.scenario_id)
			return;
		
		var previous = this.selectedOverlay.value;
		
		this.exitMode();
		
		
		if(previous == this.overlayMaps.overlays[i].value) // it's the same mode, so we just exit
			return;
			
		this.selectedOverlay = this.overlayMaps.overlays[i];
		this.selectedOverlay.handler.parent = this;
		this.selectedOverlay.handler.map = this.props.map.current;
		this.selectedOverlay.handler.context = this.props.context;
		this.enterMode();
		
		this.forceUpdate();
	}

	render() {
		if(!this.props.project || !this.selected)
			return;
		
		return (<>
			{
				this.selectedOverlay.handler && 
				this.selectedOverlay.handler.panel && 
				this.selectedOverlay.handler.panel()
			}
			<div className="layer-panel" ref={this.layerPanel} >
				<div className="separator">
					<Stack size={16} /> Map overlays
				</div>
				<div className="section">
					<div className="overlays">

						<div className={"alternatives " + (!this.props?.context?.tc?.scenario?.scenario_id ?  "disabled" : "") }>
							{
								this.overlayMaps.overlays.map((a, k)=>{
									return (<div key={k} className={"layer_wrp "+(a.label == this.selectedOverlay.label ? "selected" : "")}><div style={{backgroundImage:'url(/images/'+a.thumbnail+')'}} onClick={(e)=>{this.handleChangeOverlay(k, e);}} className="layer">{a.label}</div></div>)
								})
							}
						</div>
					</div>
				</div>
				<div className="separator mt-3">
					<MapTrifold size={16} />Base map
				</div>
				<div className="section">
					<div className="current">
						<div className="layer" value={this.selected.value} style={{backgroundImage:'url(/images/'+this.selected.thumbnail+')'}}>
							{this.selected.label}
						</div>
					</div>
					<div className="alternatives">
						{
						this.baseMaps.map((a, k)=>{
							if((!a.country || (a.country && a.country == this.props.project.country)) && a.label != this.selected.label)
								return (<div key={k} className={"layer_wrp "+(a.label == this.selected.label ? "selected" : "")}><div style={{backgroundImage:'url(/images/'+a.thumbnail+')'}} onClick={a.onClick ? a.onClick : (e)=>{this.changeLayer({value:k}, e)}} className="layer">{a.label}</div></div>)})
						}
					</div>
				</div>		
			</div>	
		</>);
	}
}
export default LayerPanel;